module.exports = __webpack_public_path__ + "static/media/alert.477d6156.mp3";